module.exports = __webpack_public_path__ + "img/drone_04_H.d11d9b6b.webp";